import clsx from "clsx";
import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import expandIcon from "../../assets/images/expand.svg";
import { useStyles } from "../../assets/jss/DriverDetails";
import CustomButton from "../../components/CustomComponents/CustomButton/CustomButton";
import CustomGrid from "../../components/CustomComponents/CustomGrid/CustomGrid";
import CustomPaper from "../../components/CustomComponents/CustomPaper/CustomPaper";
import CustomTypography from "../../components/CustomComponents/CustomTypography/CustomTypography";
import DateTime from "../../components/DateTime/DateTime";
import DriverDetails from "../../components/DriverDetails/DriverDetails";
import DriverScoreCard from "../../components/DriverDetails/DriverScoreCard";
import DriverDetailsTab from "../../components/DriverDetailsTab/DriverDetailsTab";
import ErrorAlert from "../../components/ErrorAlert/ErrorAlert";
import { getDriverDetails } from "../../services/GetDriverDetail";
import { getUserData, getCompaEnabledForView, getDistractionEnabledForView, getUserRBAC } from "../../services/LocalStorageService";
import { EntityAccess, RBAC_CODE } from "../../config/app-globals.enum";
import backButton from "../../assets/images/back_button.svg";
import { Fab } from "@material-ui/core";
import noteFabIcon from "../../assets/images/noteFabIcon.svg";
import NoteNotification from "../../assets/images/NoteNotification.svg";
import DriverNotePopup from "../../components/DriverNotePopup/DriverNotePopup";
import { adminGetDriverNotes } from "../../services/AdminUserService";
import DriverNote from "../../assets/images/driverNote.svg";


export default function DriverDetailsView(props) {
    const params = useParams();
    const { t } = useTranslation();
    const localStorageData = getUserData();
    const [currentDate] = useState(new Date());
    const history = useHistory();
    const classes = useStyles();
    const [googleAnalyticsId] = React.useState(process.env.REACT_APP_GOOGLE_TAG_ID);
    const [isExpandView, setIsExpandView] = React.useState(true);
    const [isCompaEnabledForView] = React.useState(getCompaEnabledForView);
    const [isDistractionEnabledForView] = React.useState(getDistractionEnabledForView);
    const [userRBAC] = React.useState(getUserRBAC(RBAC_CODE.UPSERT_NOTE, props));

    /* Driver ID, Selected Tab, Sort Order from props  */
    const userIdParam = props.match.params.id ? props.match.params.id : null;

    const rightSliderContainer = useRef<any>();
    const [expandDrawer, setExpandDrawer] = useState(false);

    useEffect(() => {
        if (rightSliderContainer && rightSliderContainer.current) {
            console.log('drawer open');
            if (expandDrawer) {
                rightSliderContainer.current.style.right = 0;
            } else {
                rightSliderContainer.current.style.right = `-${rightSliderContainer.current.offsetWidth}px`;
                console.log(`-${rightSliderContainer.current.offsetWidth}px`);
            }
        }
    }, [expandDrawer]);

    useEffect(() => {
        if (
            userIdParam === null ||
            (userIdParam !== localStorageData.Id &&
                localStorageData.AccessLevel === 1)
        ) {
            history.push("/dashboard");
        }
    }, []);

    const [userId] = useState(props.match.params.id === null || props.match.params.id === undefined ? props.location.state === null || props.location.state === undefined ? localStorageData.Id : props.location.state.userId : props.match.params.id);
    const [sortBy] = useState(props.location.state === null || props.location.state === undefined ? "" : props.location.state.sortBy);
    let _showTab = "SPEEDING";
    if (isCompaEnabledForView && isCompaEnabledForView === EntityAccess.ALLOWED && props.location.hash !== undefined && props.location.hash === '#tabTrips') {
        _showTab = "TRIPS";
    } else if (isDistractionEnabledForView && isDistractionEnabledForView === EntityAccess.ALLOWED && props.location.hash !== undefined && (props.location.hash === '#tabDistraction' || props.location.hash === '#DISTRACTION')) {
        _showTab = "DRIVER_DISTRACTION";
    } else if (props.location.hash !== undefined) {
        let strArr = props.location.hash.split("#");
        if (strArr && strArr.length > 1) {
            _showTab = strArr[1];
        }
    }
    const [showTab, setShowTab] = useState(_showTab);
    /* Driver Details */
    const [driverDetails, setDriverDetails] = useState({
        loading: true,
        data: {},
        driverRecordFound: true,
        driverDetailsErrorMessage: "",
    });
    const [isApiFailed, setIsApiFailed] = useState(false);
    const [statusValue, setStatusValue] = React.useState();
    const [alertMessage, setAlertMessage] = React.useState("");
    const [isAlertOpen, setIsAlertOpen] = React.useState(false);

    const changeApiStatusCodeFunc = (status) => {
        if (status.code && status.code !== 0 && status.code !== 200) {
            setStatusValue(status.code);
            setAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setIsAlertOpen(true);
        }
    };

    const loadData = async () => {
        setStatusValue(null);
        setAlertMessage("");
        setIsAlertOpen(false);
        const data = await getDriverDetails(userId, params);
        if (data && (data.status.code === 0 || data.status.code === 200 || data.status.code === 201) && data.content) {
            setDriverDetails({
                ...driverDetails,
                data: data.content,
                driverRecordFound: true,
                loading: false,
            });
        } else {
            setIsApiFailed(true);
            setDriverDetails({
                ...driverDetails,
                driverRecordFound: false,
                loading: false,
            });
            if (data && data.status) {
                changeApiStatusCodeFunc(data.status);
            }
        }
    }

    useEffect(() => {
        loadData();
        getNoteData();
    }, []);

    const handleExpandView = (param) => {
        setIsExpandView(param);
    }

    const goBackFunc = () => {
        (params.impersonationid && history.length > 1) || !params.impersonationid ? history.goBack() : history.push(`/dashboard/impersonation/${params.impersonationid}`);
    }

    const [drawerOpen, setDrawerOpen] = useState(false);
    const [noteData, setNoteData] = useState({ noteList: [] });
    const [isNoteAdded, setIsNoteAdded] = useState(false);
    const [isGetNoteApi, setIsGetNoteApi] = useState(false);
    const [isGetNoteApiFailed, setIsGetNoteApiFailed] = useState(false);

    async function getNoteData() {
        const data = await adminGetDriverNotes(userId, params);
        if (data && (data.status.code === 0 || data.status.code === 200 || data.status.code === 201) && data.content) {
            if (data.content.length) {
                data.content.find(o => o.readStatus === 0) ? setIsNoteAdded(true) : setIsNoteAdded(false);
                setNoteData({ noteList: data.content });
            } else {
                setNoteData({ noteList: data.content });
                setIsNoteAdded(false);
            }
            setIsGetNoteApi(true);
            setIsGetNoteApiFailed(false);
        } else {
            setIsGetNoteApi(false);
            setIsGetNoteApiFailed(true);
        }
    }

    const noteDetailsDialogFunc = (isOpen, action) => {
        setDrawerOpen(isOpen);
        if (action) {
            getNoteData();
        }
    };

    return (
        <>
            <CustomGrid container spacing={0} justifyContent="space-between">
                <CustomGrid item>
                    <CustomTypography
                        component="h1"
                        variant="h5"
                        className={classes.headerTitle}
                    >
                        <img src={backButton} onClick={goBackFunc} style={{ marginRight: "20px", cursor: "pointer" }} alt="Back" />
                        {t("DRIVER_DETAILS")}{" "}
                    </CustomTypography>
                </CustomGrid>
                <CustomGrid item>
                    <CustomTypography className={classes.headerDate} component="p" variant="h6" >
                        {t("LAST_UPDATED_ON")}{" "}
                        <DateTime inputDate={currentDate} returnFormat="ddd" />,{" "}
                        <DateTime inputDate={currentDate} returnFormat="DD MMM YYYY" /> |{" "}
                        <DateTime inputDate={currentDate} returnFormat="hh:mm a" />
                    </CustomTypography>
                </CustomGrid>
            </CustomGrid>
            {driverDetails.driverRecordFound ? (
                <>
                    <CustomGrid container spacing={2}>
                        <CustomGrid className={clsx(classes.driverDetailsContainer, isExpandView ? classes.driverDetailsContainerExpanded : '')} item xs={12} lg={6} md={8}>
                            <DriverDetails data={driverDetails} isExpandView={isExpandView} isApiFailed={isApiFailed} {...props} />
                        </CustomGrid>
                        <CustomGrid className={clsx(classes.driverDetailsContainer, isExpandView ? classes.driverDetailsContainerExpanded : '')} item xs={12} lg={3} md={6}>
                            <DriverScoreCard data={driverDetails} isExpandView={isExpandView} scoreType="ENGAGEMENT" isApiFailed={isApiFailed} {...props} />
                        </CustomGrid>
                        <CustomGrid className={clsx(classes.driverDetailsContainer, isExpandView ? classes.driverDetailsContainerExpanded : '')} item xs={12} lg={3} md={6}>
                            <Fab
                                color='primary'
                                className={classes.fabButton}
                                onClick={() => noteDetailsDialogFunc(true, false)} >
                                {userRBAC && userRBAC.isAccessible !== EntityAccess.ALLOWED ?
                                    isNoteAdded ? <img src={NoteNotification} /> : <img src={DriverNote} />
                                    :
                                    <img src={noteFabIcon} />
                                }
                            </Fab>
                            <DriverScoreCard data={driverDetails} isExpandView={isExpandView} scoreType="PRAISO" isApiFailed={isApiFailed} {...props} />
                            <DriverNotePopup
                                open={drawerOpen}
                                anchor={"right"}
                                onClose={() => setDrawerOpen(false)}
                                // driverData={driverDetails.data}
                                isNoteAdded={isNoteAdded}
                                setIsNoteAdded={setIsNoteAdded}
                                driverId={userId}
                                getNoteData={getNoteData}
                            />
                        </CustomGrid>
                    </CustomGrid>
                    <CustomGrid container spacing={2} justifyContent="flex-end">
                        <CustomGrid item>
                            {
                                isExpandView && showTab === 'TRIPS' ?
                                    <CustomButton className={classes.actionExpandCollapseBtn} onClick={async () => handleExpandView(false)}>
                                        {t('EXPAND_VIEW')}
                                        <img className={classes.imageIcon} src={expandIcon} />
                                    </CustomButton>
                                    :
                                    null
                            }
                        </CustomGrid>
                    </CustomGrid>
                    <DriverDetailsTab setShowTab={setShowTab} userId={userId} sortBy={sortBy} showTab={showTab} isExpandView={isExpandView} handleExpandView={handleExpandView} />
                </>
            ) : (
                <CustomPaper elevation={0} square className={classes.driverCard} style={{ padding: "2em" }} >
                    <CustomTypography component="h1" variant="h5" className={classes.headerTitle} >
                        {driverDetails.driverDetailsErrorMessage}
                    </CustomTypography>
                </CustomPaper>
            )}
            <ErrorAlert code={statusValue} message={alertMessage} isOpen={isAlertOpen} isClose={(isClose) => setIsAlertOpen(!isClose)} />

            <Helmet>
                <script
                    async
                    src={`https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsId}`}
                ></script>
                <script>
                    {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', "${googleAnalyticsId}");
        `}
                </script>
            </Helmet>
        </>
    );
}
